import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(/* webpackChunkName: "color-trend-detail" */ './index')
);

export default prerenderedLoadable(Page);